import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { CompanyDepartment } from './companyDepartment';
import { CompanyInfoFragment } from './fragments';
import { VolumeLicense } from './volumeLicense';

export const COMPANIES_QUERY = gql`
	query Companies {
		companies {
			...CompanyInfoFragment
		}
	}
	${CompanyInfoFragment}
`;

export const COMPANY_QUERY = gql`
	query Company($id: ID!) {
		company(id: $id) {
			...CompanyInfoFragment
		}
	}
	${CompanyInfoFragment}
`;

export type Company = {
	id: string;
	title: string;
	active: boolean;
	userDepartment?: string;
	userRole?: 'COMPANY_ADMIN' | 'COMPANY_DEPARTMENT_ADMIN';
	departments: CompanyDepartment[];
	volumeLicenses?: VolumeLicense[];
};

export const useCompanies = (): undefined | null | Company[] => {
	const { data } = useQuery(COMPANIES_QUERY);
	return React.useMemo(() => data?.companies, [data?.companies]);
};

export const useCompany = (id?: string): undefined | null | Company => {
	const { data } = useQuery(COMPANY_QUERY, { variables: { id }, skip: !id });
	return React.useMemo(() => (!id ? null : data?.company), [data?.company, id]);
};
